import React, { useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import './NotFound.css'; // Import your CSS file for styling
import { Button } from 'antd';

const NotFound = () => {
  const navigate = useNavigate();

  // Scroll to the top of the page when component mounts
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const goback = () => {
    navigate(-1);
}


return (
  <div className="not-found-container">
    <h2>404 - Page Not Found</h2>
    <p>The page you are looking for does not exist.</p>
    <Button className="home-link" type='text' onClick={goback}>Go Back</Button>
    <Link className="home-link" to={'/'}>Go Home</Link>
  </div>
);
}

export default NotFound;
